// #region Imports

import * as InputHandler from "./inputHandler"
import * as TypeWriter from "./typeWriter"

// #endregion Imports

// #region Exports

export function initialize(): void {
    InputHandler.wireSearchField();
    TypeWriter.initialize();
}

// #endregion Exports

// #region Private functions

// #endregion Private functions